export enum CollectionState {
  live = 0,
  pending = 1,
  rejected = 2,
  updated = 3,
  draft = 4,
  deleted = 5
}
